module.exports = __webpack_public_path__ + "static/gapych2-9acafef9a3234c5f89c38912e6bf674f.png";